/*
 * a class specifically for RD EP UI handling
 */
import EPUIController from './EPUIController';
import WidgetTypes from '../core/enums/WidgetTypes';
import TempCache from '../core/enums/TempCache';
// import PokeMessageJob from '../PokeMessageJob';
import Utils from '../core/Utils';
import ChatMode from '../core/hooks/ChatMode';
import { LogoLocation } from '../core/enums/Enum';
import TempStorageCache from '../core/hooks/TempStorageCache';
import createElement from '../core/hooks/createElement';
import ChatEvents from '../core/hooks/ChatEvents';
import WidgetStates from '../core/hooks/WidgetStates';
import getStorageAPIValue from '../core/hooks/getStorageAPIValue';
import showElement from '../core/hooks/showElement';
import disableTypingInput from '../core/hooks/disableTypingInput';
import logIt from '../../logIt';
import applyResizeClassOnInput from '../core/hooks/resizeChatInput';
import toggleSendButtonClasses from '../core/hooks/toggleSendButton';
import { getNonSMSAndScriptLanguages } from '../core/hooks/SwitchLanguage';

export default class RDEPUIController extends EPUIController {
    constructor(options) {
        super(options);
        const me = this;
        me.options = options;
        Object.assign(me.options.elements, {
            multiLanguage_dropdown_wrapperSelector: '.apexchat_rd_ep_language_select_wrapper',
            multiLanguage_dropdown_container: 'apexchat_rd_ep_language_select_wrapper',
            multiLanguage_dropdown_select: 'apexchat_rd_ep_language_select',
            emoticonsAreaSelector: '.livechat_emoticons_area_content',
            clickSelector: '#livechat_send_message_button',
            closeSelector: '.apex-ep-closemodel',
            typingIndicatorSelector: '.apexchat_rd_ep_typing',
            agentTitle: '.apex-profile-agent', // participantsSelector
            regionLabelSelector: '.apex-ep-rd-phone',
            rDEPHeaderLogoURLSelector: '.apex_rd_apex_title_logo',
            emojiIconSelector: '.livechat_emoticons_area',
            emojiContentSelector: '.livechat_emoticons_area_content',
            sidePanelHeaderText: '#apexchat-ep #apexchat-span-greeting',
            sidePanelWelcomeText: '#apexchat-ep .apex_rd_ep_hello_title',
            agentOnlineText: '.apex-profile-agent-online',
            textboxContainerSelector: '#apexchat-ep .apex-msg-wrapper',
            actionMenuSelector: '#apexchat_custom_dropdown_menu'
        });
        me.options.model.isRoundedDynamic = true;
        me.rdActionButtons();

        // [V3 - RD - EP] Profile level custom logo for header
        const rDEPHeaderLogoURL = me.$(me.options.elements.rDEPHeaderLogoURLSelector, me.context);
        me.options.model.rDEPHeaderLogoURL =
            me.options.model.rDEPHeaderLogoURL || 'apexchat-logo.png'; // default sample logo
        me.setLogoLocation({
            location: me.options.model.rDEPLogoLocation,
            logoUrl: me.options.model.rDEPHeaderLogoURL,
            logoSize: `${me.options.model.rDEPLogoSize}%`
        });
        me.options.model.rDEPLogoSize = me.options.model.rDEPLogoSize || '50';
        if (me.options.model.rDEPHeaderLogoURL.indexOf('apexchat-logo.png') === -1) {
            rDEPHeaderLogoURL.css({
                'background-image': `url(${encodeURI(me.options.model.rDEPHeaderLogoURL)})`,
                'background-size': `${me.options.model.rDEPLogoSize}%`
            });
            me.context.documentElement.style.setProperty('--epLogoImgSize', `${me.options.model.rDEPLogoSize}%`);
            // summary: else if is introduced in case of those skins who are old have have not setup profile level header logo
            // and are still using the old themebuilder based logo.
        } else if (me.options.model.rDEPHeaderLogoURL.indexOf('apexchat-logo.png') > -1) {
            // apexchat-logo is the default logo which appears when there is no logo in profile setup
            rDEPHeaderLogoURL.css({
                'background-size': `${me.options.model.rDEPLogoSize}%`
            });
        }
        // ExitPopup Side Panel content is dynamic here we are no longer using hardcoded values.
        me.options.model.sidePanelHeaderText =
            me.options.model.sidePanelHeaderText || TempCache.EP_SIDEPANEL_HEADER_TEXT; // for safe-side if value null, we are using default value.
        me.options.model.sidePanelWelcomeText =
            me.options.model.sidePanelWelcomeText || TempCache.EP_SIDEPANEL_WELCOME_TEXT;
        // For non Rd Plus Theme
        if (!ApexChat.IsRoundedDynamicPlusTheme) {
            const regionLabel = me.$(me.options.elements.regionLabelSelector, me.context);
            if (me.options.model.regionLabel) {
                regionLabel.text(me.options.model.regionLabel);
            }
            me.$(me.options.elements.sidePanelHeaderText, me.context).html(
                me.options.model.sidePanelHeaderText
            );
            me.$(me.options.elements.sidePanelWelcomeText, me.context).html(
                me.options.model.sidePanelWelcomeText
            );
        }

        me.changeFontSize(
            me.options.elements.sidePanelHeaderText,
            'apexchat_ep_side_header_small_font',
            18
        );
        me.changeFontSize(
            me.options.elements.sidePanelWelcomeText,
            'apexchat_ep_side_welcome_small_font',
            29
        );

        const innerWrapper = me.$(
            `#${WidgetTypes.ExitPopup + WidgetStates.ShownMaximized}`,
            me.context
        );
        innerWrapper.css('cssText', 'bottom: 30px !important;position:absolute; right: 25px'); // CHAT-5421 {V3] RD EP language drop down is being cut off.

        const helloRegion = me.$('#apexchat-ep #apexchat-span-hello .apex_rd_ep_hello', me.context);
        helloRegion.css('cssText', 'top: 40px;');
        // registering emoji events
        me.addEmojiEvents();
        import(/* webpackChunkName: "pokeMessageJob" */ '../pokeMessage/PokeMessageJob').then(
            (module) => {
                const PokeMessageJob = module.default;
                me.pokeMessageJob = new PokeMessageJob(
                    Object.assign(me.options, {
                        isChatActive: me.isChatActive,
                        isPageRefreshed: me.isPageRefreshed,
                        postMessage: me.postMessage,
                        preserveChatArray: me.preserveChatArray
                    })
                );
            }
        );
        me.subscribe(ChatEvents.onOperatorNotAvailable, () => {
            me.$(me.options.elements.transferChatSelector, me.context).remove();
        });
        me.subscribe(ChatEvents.OnChatTransferredToOperator, () => {
            me.options.model.aiBotEnabled = false;
            me.setTransferredToLiveAgent();
            me.$(me.options.elements.transferChatSelector, me.context).remove();
            if (
                me.multiLanguage_dropdown_wrapper &&
                me.options.model.showMultiLangDropDown &&
                Array.isArray(me.nonSMSLanguages) &&
                me.nonSMSLanguages.length > 1
            ) {
                showElement(me.multiLanguage_dropdown_wrapper, true);
            }
            me.adjustRdActionMenu();
        });
        me.subscribe(ChatEvents.OnPredefinedCompleted, (args) => {
            if (!me.isChatActive()) {
                me.pokeMessageJob?.start(); // Start Poke Messages when all predefined messages appeared.
            }
        });
        me.adjustRdActionMenu();
    }

    // toggles new action icons based on chatMode and scriptBotEnabled flags
    // 1- show only Restart Chat icon if chatMode==Windowed
    // 2- show new Rd menu for Dom with Restart and popout items if scriptBotEnabled=true
    // 3- show just popout icon for DOM if scriptBotEnabled=false
    adjustRdActionMenu() {
        const me = this;
        // TODO: This function should not be executed when chatMode is Exit popup. we have to remove this function in exit popup case
        const reShowIntervalWindowed =
            me.options.reShowIntervalMinutes || me.options.model.reShowIntervalMinutes;
        if (
            me.isWindowedStarted() ||
            (me.options.chatMode && me.options.chatMode == ChatMode.Windowed)
        ) {
            // me.$('.apexchat_header_dropdown:not(.apexchat_tooltip)', me.context).remove();
            if (!me.options.model.scriptBotEnabled && !me.options.model.hasSmsNumber) {
                me.hideScriptbotMenuItems();
                me.$('.livechat_Headericon_wrapper', me.context).hide();
                me.$('.apexchat_header_dropdown', me.context).hide();
            } else if (me.isTransferredToLiveAgent()) {
                me.$('.apexchat_restartbutton', me.context).hide();
                if (reShowIntervalWindowed) {
                    setTimeout(() => {
                        me.rdWindowedActionButtons();
                    }, reShowIntervalWindowed * 60 * 1000);
                }
            } else {
                me.hideScriptbotMenuItems();
                me.$('.apexchat_header_mute_button', me.context).hide();
                if (reShowIntervalWindowed) {
                    setTimeout(() => {
                        me.rdWindowedActionButtons();
                    }, reShowIntervalWindowed * 60 * 1000);
                }
            }
            if (me.isTransferredToLiveAgent()) {
                me.$('.apexchat_restartbutton', me.context).hide();
                me.$('#menuItemRestart', me.context).hide();
                me.$('#menuItemRestart', me.context).hide();
                if (!me.options.model.hasSmsNumber) {
                    me.$('.apexchat_header_mute_button', me.context).show();
                    me.$('.apexchat_header_dropdown', me.context).hide();
                } else {
                    me.$('.apexchat_header_mute_button', me.context).hide();
                }
            }
        } else {
            me.rdActionButtons();
            if (me.options.model.scriptBotEnabled || me.options.model.hasSmsNumber) {
                me.$('.apexchat_header_mute_button', me.context).hide();
                me.hideScriptbotMenuItems();
            } else if (!me.options.model.scriptBotEnabled) {
                me.$('.apexchat_header_dropdown', me.context).hide();
                me.$('.apexchat_focus_remove', me.context).hide();
            } else {
                me.rdActionButtons();
            }
            if (me.isTransferredToLiveAgent()) {
                me.$('#menuItemRestart', me.context).hide();
                me.$('.apexchat_header_mute_button', me.context).show();
                me.$('.apexchat_header_dropdown', me.context).hide();
                me.$('#menuItemRestart', me.context).hide();
            }
        }
    }

    hideScriptbotMenuItems() {
        const me = this;
        if (!me.options.model.scriptBotEnabled) {
            me.$('#menuItemRestart', me.context).hide();
            me.$('#menuItemTransfer', me.context).hide();
        }
    }
    changeFontSize(element, fontCss, length) {
        // change font size depend upon length of text.
        const me = this;
        me.$(element, me.context).each(function () {
            const el = me.$(this);
            const textLength = el.html().length;
            if (textLength > length) {
                el.addClass(fontCss);
            }
        });
    }

    setLogoLocation(options) {
        const me = this;
        switch (options.location) {
            case LogoLocation.Header:
                me.$('#apexchat-rd-logo-wrapper', me.context).show();
                me.$('#apexchat_ep_brand_logo', me.context).hide();
                break;
            case LogoLocation.Side: // do here
                me.$('#apexchat_ep_brand_logo', me.context).show();
                // we need to hide these specifc
                me.$('.apex_rd_apex_title_logo', me.context).hide();
                me.$('#apexchat-rd-logo-wrapper svg', me.context).css('opacity', '0');
                me.$('#apexchat-span-hello', me.context).hide();
                me.$('#apexchat_ep_img_brand_logo', me.context).attr('src', options.logoUrl);
                me.$('#apexchat_ep_img_brand_logo', me.context).css('width', options.logoSize);
                break;
        }
    }

    showTyping(args) {
        const me = this;
        me.typingIndicator.show();
    }

    hideTyping(args) {
        const me = this;
        me.typingIndicator.hide();
    }

    onTypingArrived(args, self) {
        const me = this;
        // TODO: will implement UI after integrating with Mahad's PR changes
        // var msgs = me.$('.apexchat_auto_genned_message_wrapper', me.context);
        // var msgCount = msgs.length;
        // var lastMsg = msgs[msgCount - 1];
        // var indicator = me.$("<div class='apexchat_rd_ep_typing'><span class='apexchat_rd_rect'></span ><span class='apexchat_rd_rect'></span><span class='apexchat_rd_rect'></span><span class='apexchat_rd_glider'></span></div>", me.context);
        // msgs.append(indicator);
        // logIt(args);
        // if (args.indicator) {
        //    me.typingIndicator.show();
        // }
        // else {
        //    me.typingIndicator.hide();
        // }
        if (args.indicator) {
            // restarting chat sets messages container's html empty removing typing indicator as well therefore checking and adding it again if removed
            if (!me.$('.apexchat_rd_ep_typing', me.context).length) {
                me.messagesContainer.append(me.typingIndicator.prop('outerHTML'));
                me.typingIndicator = me.$('.apexchat_rd_ep_typing', me.context);
            }
            me.typingIndicator.show().removeClass('disabled');
        } else {
            me.typingIndicator.addClass('disabled');
            // me.$('.apexchat_rd_chat_typing', me.context).hide();
        }
        me.autoScroll();
    }

    onMessageArrived(m, initialLoad, index, lastSplitMsgCallback) {
        const me = this;
        super.onMessageArrived(m, initialLoad, index, lastSplitMsgCallback).then(_ => {
            me.typingIndicator.hide();
        });
        setTimeout(() => {
            me.$(`
                .apexchat_contact_textarea,
                .apexchat_contact_qt`,
                me.context
            ).on('input, keyup', function (e) {
                toggleSendButtonClasses({ e, me });
            });
        }, 100);
    }

    /**
     * Adjusts the height of the text area based on the number of lines of text entered by the user.
     * Also toggles the send button classes based on whether the user has sent the text or not.
     * @memberof RDEPUIController
     * @instance
     * @param {RDEPUIController} me - The instance of the RDEPUIController class.
     */
    adjustTextAreaHeight(me) {
        me.$(`
            ${me.options.elements.clickSelector}`,
            me.context
        ).on('click', function (e) {
            toggleSendButtonClasses({ me, forceInactive: true });
        });
        const events = ['input', 'keyup', 'cut', 'paste'];
        events.forEach(event => {
            me.$(`
                ${me.options.elements.textboxSelector}, 
                ${me.options.elements.autoCompleteInput}`,
                me.context
            ).on(event, function (e) {
                const isCleanUp = e.keyCode == 13 || e.target.value?.length == 0;
                toggleSendButtonClasses({ e, me });
                setTimeout(() => {
                    applyResizeClassOnInput({
                        me,
                        textarea: '.livechat_typing_textarea',
                        wrapper: '.livechat_typing_area',
                        mainWrapper: '#apexchat-ep',
                        classes: {
                            1: 'livechat_single_line',
                            2: 'livechat_two_lines',
                            3: 'livechat_three_lines',
                            4: 'livechat_four_lines',
                            max: 'livechat_max_lines'
                        },
                        cleanup: isCleanUp
                    });
                }, 200);
            });
        });
    }

    // adjustTextAreaHeight(e, me, options) {
    //     const targetElem = me.$(options.targetElement, me.context);
    //     // this resets to the min-height defined in the targetElement.
    //     const resetHeight = targetElem.css('minHeight');
    //     if (options) {
    //         if (options.reset || e.scrollHeight < 50) {
    //             targetElem.css({ height: resetHeight });
    //         } else if (e.scrollHeight > 50) {
    //             targetElem.css({ height: '1px' });
    //             targetElem.css({ height: `${e.scrollHeight}px` });
    //         }
    //     }
    // }

    bind() {
        const me = this;
        super.bind();
        // me.$(me.options.elements.textboxSelector, me.context).apexChatFlexTextArea(
        //    { context: me.context }
        // );
        const ghostElement = createElement(
            null,
            null,
            'apexchat_rd_chat_invisible_textarea'
        );
        me.$('.apex-msg-type', me.context).append(ghostElement);

        const transcriptContent = me.$('.apex-transcript', me.context);
        me.$(me.options.elements.textboxSelector, me.context).on('input', function (e) {
            me.$(me.options.elements.inputContainerSelector, me.context).removeValidationTooltip({
                toolTipCss: 'livechat_validation_tooltip'
            });
        });
        me.adjustTextAreaHeight(me);

        // disable typing input area before predefinded message show
        disableTypingInput.bind2(me)(
            me.options.elements.inputContainerSelector,
            '', me.options
        );
    }

    showPokeMessages(m) {
        const me = this;
        super.showPokeMessages(m);
    }

    hidePokeMessages() {
        const me = this;
        super.hidePokeMessages();
        if (!me.isChatActive() && me.pokeMessageJob) {
            // when we click I'm back restart poke message job, it will reset interval.(For RD EP only)
            me.pokeMessageJob?.start();
        }
    }

    endChat() {
        const me = this;
        super.endChat();
        me.multiLanguage_dropdown_wrapper.remove();
        ApexChat.storageAPI.StoreTemp('livechat_exitpopup_is_closed', true);
    }

    sendMessage(el) {
        const me = this;
        me.resetInputHeightAfterSendMessage();
        super.sendMessage(el);
    }

    resetInputHeightAfterSendMessage() {
        const me = this;
        const textAreaContainer = me.$('.apex-msg-type', me.context);
        textAreaContainer.removeClass(
            'apexchat_rd_ep_textarea_max_height  apexchat_rd_ep_textarea_two_lines'
        );
        // CHAT-5821-Reset Height of text area input
        // After sending message of 2-3 lines reset height of text input back to normal
        me.adjustTextAreaHeight(me, {
            cleanup: true,
        });
    }

    renderMultiLanguageDropDown(config) {
        const me = this;
        super.renderMultiLanguageDropDown(config);
    }

    async implementMultiLanguageSupport(config) {
        const me = this;
        if (!me.nonSMSLanguages) {
            let supportedLanguages = this?.options?.model?.supportedLanguagesList || [];
            me.nonSMSLanguages = supportedLanguages.filter(getNonSMSAndScriptLanguages);
        }
        if (!me.options.model.showMultiLangDropDown || (me.nonSMSLanguages && me.nonSMSLanguages.length <= 1)) {
            // todo have to revise element selection logic
            me.multiLanguage_dropdown_wrapper.style.display = 'none';
            return;
        }
        const chatLanguageInSession = TempStorageCache.get('apex_rd_ep_chat_language');
        if (chatLanguageInSession) {
            TempCache.chatLanguage = chatLanguageInSession;
        }
        const textPairValue = [];
        for (let i = 0; i < me.nonSMSLanguages.length; i++) {
            const item = me.nonSMSLanguages[i];
            textPairValue.push({
                value: item.threeLetterISOLanguageName,
                text: item.languageFullName,
                selected: i == 0
            });
        }
        if (me.options.model && me.options.model.scriptBotEnabled) {
            me.multiLanguage_dropdown_wrapper.style.display = 'none';
        } else {
            //me.multiLanguage_dropdown_wrapper.style.display = 'block';
        }
        const langSelect = me.$(
            `#${me.options.elements.multiLanguage_dropdown_select}`,
            me.context
        );
        langSelect.populateSelectList(textPairValue);

        const module = await import(/* webpackChunkName: "dropSelect" */ '../../libs/dropSelect')
        const pluginDropSelect = module.default;
        pluginDropSelect(me.$);
        langSelect.apexChatDropSelect({
            className: 'apexchat_rd_ep_language_select',
            wordWrap: false,
            context: me.context, // Pass context in Drop select Dropdown
            callBack(value) {
                const selectedItem = me.nonSMSLanguages.filter(
                    (item) => item.threeLetterISOLanguageName == value
                );
                me.chatLanguageName = selectedItem[0].languageFullName;
                TempStorageCache.add('apex_rd_ep_chat_language', value, true); // we need this cross page-reloads
                // Scenarios:
                // 1. item is being set on page-reloads, so no need to fire the following
                // 2. allow to fire when lang changes 2nd time
                if (
                    !chatLanguageInSession /* Scenario#1 */ ||
                    TempCache.chatLanguage != value /* Scenario#2 */
                ) {
                    me.switchLang.requestTransferringChat({ ...config, chatLanguageName: me.chatLanguageName });
                }
                TempCache.chatLanguage = value;
            }
            // className: 'apexchat_rd_ep_language_select'
        });
        if (chatLanguageInSession) {
            // item already selected? set it again; e.g. in reload scenario
            const langDropSelect = me.$(
                `#${me.options.elements.multiLanguage_dropdown_select}`,
                me.context
            );
            me.setSelectedDropdownItem(langDropSelect, chatLanguageInSession);
        }
        
    }

    addEmojiEvents() {
        const me = this;
        // show emoji on mouse click
        me.$(me.context)
            .find(me.options.elements.emojiIconSelector)
            .on('click', (e) => {
                const emojiContainer = me
                    .$(me.context)
                    .find(me.options.elements.emojiContentSelector);
                if (emojiContainer.hasClass('livechat_emoticons_area_content_active')) {
                    emojiContainer.removeClass('livechat_emoticons_area_content_active');
                } else {
                    emojiContainer.addClass('livechat_emoticons_area_content_active');
                }
            });

        // hide emoji container on click on window.
        me.$(me.context).on('mouseup', (e) => {
            if (!e.target.classList.contains('apexchat_rd_emoji')) {
                me.$(me.context)
                    .find(me.options.elements.emojiContentSelector)
                    .removeClass('livechat_emoticons_area_content_active');
            }
        });
    }

    rdActionButtons() {
        const me = this;
        me.options.elements.volumeMuteUnmute = '#apexchat_volume_toggle';
        me.$('.apexchat_header_mute_button', me.context).removeAttr('style');
        me.options.elements.restartVAChatSelector = '#menuItemRestart';
        me.options.elements.transferChatSelector = '#menuItemTransfer';
        if (!me.isOperatorActive(me.options)) {
            me.$(me.options.elements.transferChatSelector, me.context).remove();
        }
        if (!me.options.model.hasSmsNumber) {
            me.$('.switchto-text-chat', me.context).remove();
        }
    }

    bindVolumeMuteEvents(el, toggleMuteClass) {
        // function for menudropdown ada compliance
        const me = this;
        if (!el) {
            return;
        }
        // el.on('keyup click', (e) => {
        //     // check if button already not selected then do the action
        //     e.stopPropagation();
        //     if (e.type == 'click' || (e.type == 'keyup' && isAcceptKey(e))) {
        //         // check for mouse click or tab and enter key
        //         me.volumeMuteUnmute();
        //         me.$(me.options.elements.actionMenuSelector, me.context).toggle(); // When restart chat overlay is visible then we should hide the action menu.
        //     }
        //     toggleMuteClass(me, el);
        // });

        "keyup click".split(" ").forEach(function (e) {
            if (!el) {
                return;
            }
            el.addEventListener(e, (e) => {
                // check if button already not selected then do the action
                e.stopPropagation();
                if (e.type == 'click' || (e.type == 'keyup' && isAcceptKey(e))) {
                    // check for mouse click or tab and enter key
                    me.volumeMuteUnmute();
                    me.$(me.options.elements.actionMenuSelector, me.context).toggle(); // When restart chat overlay is visible then we should hide the action menu.
                }
                toggleMuteClass(me, el);
            });
        })
    }

    toggleMuteClass(context, el) {
        setTimeout(() => {
            if (getStorageAPIValue(TempCache.CHAT_SOUND_ENABLED) == 'true') {
                context
                    .$(el, context.DOM)
                    .removeClass('muted')
                    .find('.apexchat_dropdown_item_content')
                    .text('Mute');
            } else {
                context
                    .$(el, context.DOM)
                    .addClass('muted')
                    .find('.apexchat_dropdown_item_content')
                    .text('Unmute');
            }
        });
    }

    bindTransferChatEvents(el) {
        // function for menudropdown ada compliance
        const me = this;
        if (!el) {
            return;
        }
        el.on('keyup click', (e) => {
            // check if button already not selected then do the action
            e.stopPropagation();
            if (e.type == 'click' || (e.type == 'keyup' && isAcceptKey(e))) {
                // check for mouse click or tab and enter key
                if (!me.uicontroller.isChatroomAlive()) {
                    // if chatroom is not alive and user click on transfer chat option
                    me.execChatStartHandler(() => {
                        // hack to resize the textarea - bringing focus back to textarea
                        me.uicontroller.messageInput.focus();
                        me.chatStarted = true;
                        logIt('loading chat room on 1st msg...');
                        me.uicontroller.loadChatRoom();
                        me.uicontroller.transferChatWhenChatroomAvailable();
                        me.uicontroller.firstMsgSent = true; // when chatroom is not alive and chat successfully transfered
                        // for all subsequent msgs
                        me.handleADA(
                            me.uicontroller.clickButton,
                            me.uicontroller.sendMessage.bind2(me.uicontroller)
                        );
                    });
                    me.options.chatTransfer = true;
                    me.uicontroller.showTyping();
                } else {
                    me.uicontroller.enableChatTransfer().then(_ => {
                        me.uicontroller.transferChat();
                    })
                }
                me.$(me.uicontroller.actionMenu, me.context).toggle(); // When restart chat overlay is visible then we should hide the action menu.
            }
        });
    }

    bindAppointmenSchedulePredefined() {
        const me = this;
        if (!me.isChatroomAlive()) {
            // if chatroom is not alive and user click on transfer chat option
            me.options.execChatStartHandler(() => {
                // hack to resize the textarea - bringing focus back to textarea
                me.messageInput.focus();
                me.chatStarted = true;
                logIt('loading chat room on 1st msg...');
                me.loadChatRoom();
                me.firstMsgSent = true;
                // for all subsequent msgs
                me.ADAHandler(me.clickButton, me.sendMessage.bind2(me.uicontroller));
            });
        }
    }
}
